import Helper from "src/support/Helper";
import Base from "./Base";

class Order extends Base {
    toObjectWithOrderID(direct_res = false) {
        let orderList = {};
        let res = {};

        if (Object.keys(direct_res).length === 0) {
            return res
        }

        if (direct_res.data.orderList !== undefined && direct_res.data.orderList.length > 0) {
            direct_res.data.orderList.map((v) => {
                orderList[Helper.UUID()] = v;
            });
            res.orderList = orderList;
        }

        if (direct_res.data.totalOrderList !== undefined) {
            res.total = direct_res.data.totalOrderList;
        }

        return res;
    }
}

export default Order;